import { useState, useEffect } from "react"
import { useFirebaseWishesDataFetch } from "../../contexts/FirebaseConnectionContext"
import ExitIconButton from "../parts/button/ExitIconButton"
// eslint-disable-next-line no-unused-vars
import Sharer from "sharer.js" //Do not delete that import, it is useful despite whatever VSCode is saying
import facebookLogo from "../../assets/images/logo-facebook.png"
import whatsAppLogo from "../../assets/images/logo-whatsapp.png"
import twitterLogo from "../../assets/images/logo-twitter.svg"
import emailLogo from "../../assets/images/logo-email.svg"
import pinterestLogo from "../../assets/images/logo-pinterest.svg"

const ShareWishesListModal = () => {
  const { giftsList } = useFirebaseWishesDataFetch()
  const [sharedText, setSharedText] = useState("")
  const [thanksText, setThanksText] = useState("")

  const sharedUrl = "https://avossouhaits.netlify.app/";
  //For Pinterest only *** Path will be replaced with an image from our website once deployed
  const sharedImage = "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80"

  const handleClick = (e, medium = "") => {
    e.preventDefault()
    let thanks = ""
    if (medium !== "" && medium === "email") {
      thanks = <span>Merci d'avoir partagé par <span className="font-bold">courriel</span>.</span>
    } else if (medium !== "") {
      thanks = <span>Merci d'avoir partagé sur <span className="font-bold">{medium.charAt(0).toUpperCase() + medium.slice(1)}</span>.</span>
    }
    setThanksText(thanks)
  }

  const linksArray = [["facebook", facebookLogo, "Logo de Facebook"], ["whatsapp", whatsAppLogo, "Logo de What'sApp"], ["twitter", twitterLogo, "Logo de Twitter"], ["email", emailLogo, "Logo mail"], ["pinterest", pinterestLogo, "Logo de Pinterest"]]
  const linksBtnArray = []
  linksArray.forEach(link => linksBtnArray.push(
    <button
      key={link[0]}
      className="h-[7vh] p-2 border-2 border-darkRed rounded transition ease-in-out hover:shadow-sm hover:shadow-darkRed scaleHover"
      data-quote={sharedText}
      data-description={sharedText}
      data-sharer={link[0]}
      data-subject="À vos souhaits"
      data-title="Ma liste de souhaits"
      data-hashtags="àvossouhaits,wishlist,listedesouhait"
      data-image={sharedImage} //absolute url to image
      data-url={sharedUrl}
      onClick={(e) => handleClick(e, link[0])}
    >
      <img key={link[0]} className="w-full h-full" src={link[1]} alt={link[2]} />
    </button>
  ))

  useEffect(() => {
    window.Sharer.init()
    return () => {
      setThanksText("")
    }
  }, [])

  useEffect(() => {
    giftsList && setSharedText(`Voici ma liste de souhaits :\n${giftsList.map(
      (gift) => "\n" + gift.title
    )}`)
  }, [giftsList])

  return (
    <div className="absolute px-6 py-4 bg-ivory flexJustifyItemsCenter flex-col rounded-md text-darkOrange" onClick={e => e.stopPropagation()}>
      <ExitIconButton />
      <h2 className="font-bold text-center">Partage ta liste</h2>
      <div className="my-4 flex justify-evenly items-center flex-wrap gap-2">
        {linksBtnArray}
      </div>
      <div className="w-full text-center">
        {thanksText !== "" && thanksText}
      </div>
    </div>
  )
}

export default ShareWishesListModal